export const FETCH_ARTICLES_GTTIPS_REQUEST = 'FETCH_ARTICLES_GTTIPS_REQUEST';
export const FETCH_ARTICLES_GTTIPS_SUCCESS = 'FETCH_ARTICLES_GTTIPS_SUCCESS';
export const FETCH_ARTICLES_GTTIPS_TRANSLATED_SUCCESS =
    'FETCH_ARTICLES_GTTIPS_TRANSLATED_SUCCESS';
export const FETCH_ARTICLES_GTTIPS_FAILURE = 'FETCH_ARTICLES_GTTIPS_FAILURE';
export const FETCH_ARTICLES_GTTIPS_CLEAN_UP = 'FETCH_ARTICLES_GTTIPS_CLEAN_UP';
export const UPDATE_GTTIPS_PAGE_START_PARAM = 'UPDATE_GTTIPS_PAGE_START_PARAM';
